<template>
	<div class="page">
		<headmenu></headmenu>
		<towmenu></towmenu>
		<div class="routerView">
			<router-view></router-view>
		</div>

	</div>
</template>

<script>
	import headmenu from '@/components/mangement/headMenu.vue';
	import towmenu from '@/components/mangement/towmenu.vue'
	export default{
		data(){
			return{

			}
		},
		components:{
			headmenu,
			towmenu
		},
    beforeCreate() {
      // console.log("111111111111111111111", window.location.href.indexOf('?'))
      //判断地址后缀，是否跳过登录页直接登录
      if ( window.location.href.indexOf('?') != -1) {
        let url = window.location.href;
        let mmm = window.location.href.split('?')[1].split('&');
        // console.log("111111111111111111111", mmm)
        this.$store.commit('toKen', mmm[0].split('=')[1]); //token
        this.$store.commit('userId', mmm[1].split('=')[1]); //用户id
        this.$store.commit('naMe', mmm[2].split('=')[1]); //用户名
        this.$store.commit('Type', mmm[3].split('=')[1]); //用户省市县类型
        this.$store.commit('RoleCode', mmm[4].split('=')[1]); //角色code
        this.$store.commit('RegionCode', mmm[5].split('=')[1]); //角色code

        localStorage.setItem('toKen',mmm[0].split('=')[1]);
        localStorage.setItem('userId',mmm[1].split('=')[1]);
        localStorage.setItem('naMe',mmm[2].split('=')[1]);
        localStorage.setItem('RoleCode',mmm[4].split('=')[1]);
        localStorage.setItem('RegionCode',mmm[5].split('=')[1]);
        // for (let i=0; i<mmm.length; i++) {
        //   console.log(mmm[i].split('='))
        // }
      }
    },
	}

</script>

<style scoped>
	.page{
		width:100%;
		height:100%;
		position: relative;
	}
	.routerView{
		position: absolute;
		left: 60px;
		top: 60px;
		right: 0px;
		bottom: 0px;
		background: #f2f2f3;
		padding:15px 15px;

	}
</style>
